import KUCatalogueScreen from "./KUCatalogueScreen";

export default KUCatalogueScreen;